import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { TextareaInputHook } from 'src/components/common/form';
import { IAssistantCreativeData, IAttribute } from 'src/lib/schemas';

interface TextAreaInputWidgetProps {
	input: IAttribute;
	validationRules: Record<string, any>;
	copyToClipboard?: string;
	maxLength?: number;
	withAssistant?: boolean;
	creativeData?: IAssistantCreativeData;
	fieldChanges?: () => void;
	setFieldValue?: (field: string, value: string) => void;
}

const TextAreaInputWidget: FC<TextAreaInputWidgetProps> = ({
	input,
	copyToClipboard,
	validationRules,
	maxLength,
	withAssistant,
	creativeData,
	fieldChanges,
	setFieldValue,
}) => {
	const { control } = useFormContext();

	const isRequred = validationRules?.required?.value;
	if (!isRequred) validationRules.required = false;
	else validationRules.required = validationRules.required.message;

	return (
		<Controller
			name={input.property}
			control={control}
			rules={validationRules}
			render={() => (
				<TextareaInputHook
					id={input.name}
					name={input.property}
					label={input.name}
					{...(copyToClipboard && { copyToClipboard })}
					placeholder={`Enter ${input.name.toLowerCase()}`}
					maxLength={maxLength}
					formControlProps={{
						minH: '125px',
					}}
					textareaProps={{
						bg: 'white',
						onChange: () => {
							fieldChanges && fieldChanges();
						},
					}}
					creativeData={creativeData}
					required={isRequred}
					withAssistant={withAssistant}
					setFieldValue={setFieldValue}
				/>
			)}
		/>
	);
};

export default TextAreaInputWidget;
